import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendHoverSoundCommand, sendClickSoundCommand } from '../../../helpers/web_to_client'

import styles from './TableHeadCell.css'

const TYPES = [
    'arrow',
    'check',
    'number',
    'role',
    'basis',
    'basisGutter',
]

const ALIGNMENTS = {
    right: 'alignRight',
    left: 'alignLeft',
    center: 'alignCenter',
}

const propTypes = {
    children: PropTypes.node,
    type: PropTypes.oneOf(TYPES),
    alignment: PropTypes.oneOf(Object.keys(ALIGNMENTS)),
    sortOrder: PropTypes.oneOf(['asc', 'desc']),
    isSortable: PropTypes.bool,
    isFirst: PropTypes.bool,
    isFluid: PropTypes.bool,
    onClick: PropTypes.func,
    tooltipId: PropTypes.string,
    tooltipTip: PropTypes.string,
}

const TableHeadCell = (props) => {
    const classNameBase = classNames(styles.th, {
        [styles.th__isSortable]: props.isSortable,
        [styles.th__isFirst]: props.isFirst,
        [styles[`th__${props.type}`]]: props.type,
        [styles[`th__${ALIGNMENTS[props.alignment]}`]]: props.alignment,
        [styles[`th__${props.sortOrder}`]]: props.sortOrder,
        [styles.th__isFluid]: props.isFluid,
    })

    const condition = props.isSortable ? (
        <div>
            <div className={classNames(styles.thCondition, styles.thCondition__active)} />
            <div className={classNames(styles.thCondition, styles.thCondition__hover)} />
        </div>
    ) : null

    const dataAttrs = props.tooltipId ? {
        'data-tip': props.tooltipTip || true,
        'data-for': props.tooltipId,
    } : {}

    return (
        <div
            className={classNameBase}
            {...dataAttrs}
            onClick={props.onClick}
            onMouseDown={props.isSortable ? sendClickSoundCommand : null}
            onMouseEnter={props.isSortable ? sendHoverSoundCommand : null}
        >
            <div className={styles.key}>{props.children}</div>
            {condition}
        </div>
    )
}

TableHeadCell.propTypes = propTypes

export default TableHeadCell



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/Table/TableHeadCell/TableHeadCell.jsx